// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__148dg","messages":"Chat_messages__3xhvF","dateDivider":"Chat_dateDivider__2e4fE"};